/* Impression SCDM — le calendrier des promotions et la table des codes.

   TOUT SE JOUE ICI, ET NULLE PART AILLEURS. Il n y a plus aucun rabais dans
   Shopify — ni code, ni rabais automatique. Ce fichier est la seule source :
   le configurateur y lit les promotions, calcule le prix, et envoie au panier
   le montant deja escompte (voir scdm-panier-technique.js). Shopify ne fait
   qu encaisser. Un seul rabais, celui qu on a montre au client, impossible de
   le compter deux fois.

   LES CODES SE MODIFIENT SANS TOUCHER AU CODE. Ils sont ecrits dans la page
   « Codes promo » (Contenu > Pages, adresse /pages/codes-promo), une ligne par
   code : CODE | pourcentage, avec deux dates facultatives pour un code
   temporaire. snippets/scdm-minimum.liquid passe le texte de cette page dans
   window.SCDM_CODES_TEXTE, on le lit ici. La page REMPLACE la table : un code
   retire de la page cesse d etre accepte. Si la page est vide, introuvable ou
   illisible, la liste de secours ci-dessous prend le relais — mieux vaut des
   codes qui fonctionnent qu une boutique qui refuse tout.

   LE PIEGE DES CODES SAISONNIERS. La table des codes n a pas de dates : ce
   sont des codes permanents, ils n expirent pas. Un code de Noel ajoute
   betement a cette table serait encore accepte au mois de juillet. On n ajoute
   donc un code saisonnier que PENDANT sa fenetre. Les rabais automatiques, eux,
   portent leurs dates : scdm.js sait deja les ignorer hors periode.

   CE QUE LE CALENDRIER NE FAIT PAS. Il ne compte pas les utilisations. Shopify
   ne connait plus les codes, donc plus personne ne bloque un code arrive a sa
   limite. C est en comptant les commandes qui portent le code qu on sait ou on
   en est, et c est a la main qu on retire un code epuise.

   POUR AJOUTER UNE PROMOTION DE SAISON : une entree ici, un bloc sur la page
   Promotions (templates/page.promotions.json). Les deux doivent dire la meme
   chose — c est le prix affiche qui engage.

   Charge en balise ORDINAIRE depuis snippets/scdm-minimum.liquid : le fichier
   doit avoir fini son travail avant scdm.js, qui lui est en defer. */

(function () {
  'use strict';

  /* Les fenetres ne se chevauchent jamais, et il reste des mois a plein prix :
     une boutique toujours en rabais apprend a ses clients a attendre. */
  var CALENDRIER = [
    { id: 'halloween', nom: 'Spécial Halloween',
      debut: '2026-10-01', fin: '2026-11-01', type: 'auto',
      paliers: [ { min: 300, pct: 0.20 }, { min: 150, pct: 0.15 }, { min: 75, pct: 0.10 } ] },

    { id: 'vendredi-fou', nom: 'Vendredi fou',
      debut: '2026-11-27', fin: '2026-12-02', type: 'auto',
      paliers: [ { min: 300, pct: 0.25 }, { min: 150, pct: 0.20 }, { min: 75, pct: 0.15 } ] },

    { id: 'noel', nom: 'Noël',
      debut: '2026-12-02', fin: '2026-12-19', type: 'code',
      code: 'NOEL2026', pct: 0.15, limite: 150 },

    { id: 'janvier', nom: 'On repart l’année',
      debut: '2027-01-06', fin: '2027-02-01', type: 'auto',
      paliers: [ { min: 300, pct: 0.20 }, { min: 150, pct: 0.15 }, { min: 75, pct: 0.10 } ] },

    { id: 'valentin', nom: 'Saint-Valentin',
      debut: '2027-02-01', fin: '2027-02-13', type: 'code',
      code: 'AMOUR10', pct: 0.10, limite: 100 },

    { id: 'securite', nom: 'Sécurité au travail',
      debut: '2027-03-01', fin: '2027-03-29', type: 'auto',
      paliers: [ { min: 300, pct: 0.20 }, { min: 150, pct: 0.15 }, { min: 75, pct: 0.10 } ] },

    { id: 'meres', nom: 'Fête des Mères',
      debut: '2027-05-01', fin: '2027-05-10', type: 'code',
      code: 'MAMAN15', pct: 0.15, limite: 100 },

    { id: 'peres', nom: 'Fête des Pères',
      debut: '2027-06-07', fin: '2027-06-21', type: 'code',
      code: 'PAPA15', pct: 0.15, limite: 100 },

    { id: 'nationale', nom: 'Fête nationale et fête du Canada',
      debut: '2027-06-21', fin: '2027-07-02', type: 'auto',
      paliers: [ { min: 150, pct: 0.15 }, { min: 75, pct: 0.10 } ] },

    { id: 'rentree', nom: 'Rentrée scolaire',
      debut: '2027-08-09', fin: '2027-08-31', type: 'code',
      code: 'ECOLE15', pct: 0.15, limite: 200 }
  ];

  window.SCDM_CALENDRIER = CALENDRIER;

  /* Liste de secours : elle ne sert que si la page « Codes promo » ne donne
     aucune ligne valide. Elle doit rester le reflet de la page. */
  var SECOURS = [
    { code: 'POF27', pct: 15 },
    { code: 'GEN09', pct: 15 },
    { code: 'JPF15', pct: 15 },
    { code: 'JOE69', pct: 15 },
    { code: 'PAT69', pct: 15 }
  ];

  /* MINUIT, HEURE DU QUEBEC — LA MEME QUE LA PAGE PROMOTIONS.

     L ancienne version devinait le decalage d apres le MOIS : avril a octobre
     en heure avancee, le reste en heure normale. Le commentaire jurait que
     c etait sans consequence parce qu aucune fenetre ne commence ni ne finit
     un jour de bascule. C etait faux : Halloween finit le 1er novembre 2026 et
     Securite au travail le 29 mars 2027, les deux jours de bascule. Une heure
     durant, une promotion expiree restait comptee.

     On demande maintenant son vrai decalage au fuseau America/Toronto. Deux
     passes : la premiere donne le decalage a minuit UTC, la seconde le corrige
     avec l instant trouve.

     ⚠ Ce calcul est recopie MOT POUR MOT dans sections/scdm-promos.liquid. Si
     l un change, l autre doit changer : la page montre la promotion, ce
     fichier calcule le rabais, et les deux doivent basculer a la meme seconde
     — sinon le client voit une offre que le prix ne lui donne pas. */
  var FUSEAU = null;
  try {
    FUSEAU = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Toronto', hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
  } catch (e) { FUSEAU = null; }

  function decalage(d) {
    var p = {};
    FUSEAU.formatToParts(d).forEach(function (x) { p[x.type] = x.value; });
    var h = p.hour === '24' ? '00' : p.hour;
    var utc = Date.UTC(+p.year, +p.month - 1, +p.day, +h, +p.minute, +p.second);
    return (utc - d.getTime()) / 60000;
  }

  function lireDate(s) {
    var m = String(s || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return null;
    if (FUSEAU) {
      var t = Date.UTC(+m[1], +m[2] - 1, +m[3], 0, 0, 0);
      var d = new Date(t - decalage(new Date(t)) * 60000);
      d = new Date(t - decalage(d) * 60000);
      return isNaN(d.getTime()) ? null : d;
    }
    /* Filet, pour un navigateur qui ne connaitrait pas les fuseaux nommes :
       l ancienne lecture par le mois. Elle se trompe d une heure deux fois par
       annee, ce qui vaut mieux que de ne plus lire aucune date. */
    var mois = parseInt(m[2], 10);
    var dec = (mois >= 4 && mois <= 10) ? '-04:00' : '-05:00';
    var vieux = new Date(m[1] + '-' + m[2] + '-' + m[3] + 'T00:00:00' + dec);
    return isNaN(vieux.getTime()) ? null : vieux;
  }

  function enCours(p, now) {
    var d = lireDate(p.debut), f = lireDate(p.fin);
    if (d && now < d) return false;
    if (f && now >= f) return false;
    return true;
  }

  /* --- lecture de la page « Codes promo » ---------------------------------

     Le texte vient d un editeur de texte riche : il peut contenir des tirets
     longs, des espaces insecables, des puces, une ligne de titre. On est donc
     large a la lecture, et strict a la validation — une ligne qui ne donne pas
     un code ET un pourcentage plausible est simplement ignoree. */

  var MOTS_VIDES = /^(code|codes|promo|promos|rabais|le|la|les)$/i;

  function lireLigne(ligne) {
    var l = String(ligne)
      .replace(/[–—−]/g, '-')        /* tirets longs, signe moins */
      .replace(/[    ]/g, ' ') /* espaces insecables, fines */
      .trim();

    if (!l || l.charAt(0) === '#') return null;          /* ligne de commentaire */

    var parts = l.split(/\s*[|;]\s*/);
    if (parts.length < 2) {
      var m = l.match(/^([^:=]+)[:=](.+)$/);             /* « CODE : 15 » ou « CODE = 15 » */
      if (!m) return null;
      parts = [m[1], m[2]];
    }

    var mots = parts[0].split(/\s+/).map(function (x) {
      return x.replace(/[^A-Za-z0-9_-]/g, '');
    }).filter(function (x) {
      return x && !MOTS_VIDES.test(x);
    });
    if (!mots.length) return null;

    var code = mots[0].toUpperCase();
    if (code.length < 2 || code.length > 24) return null;

    var pct = parseFloat(String(parts[1]).replace(',', '.').replace(/[^0-9.]/g, ''));
    if (!(pct > 0) || pct > 90) return null;             /* 0 % ou 200 % : faute de frappe */

    /* Dates facultatives, dans n importe laquelle des cases suivantes. */
    var dates = parts.slice(2).join(' ').match(/\d{4}-\d{2}-\d{2}/g) || [];

    return { code: code, pct: pct / 100, debut: dates[0] || null, fin: dates[1] || null };
  }

  function lireTexte(t) {
    var vus = {}, sortie = [];
    String(t || '').split(/\r?\n/).forEach(function (l) {
      var o = lireLigne(l);
      if (!o || vus[o.code]) return;        /* premiere ligne gagnante */
      vus[o.code] = true;
      sortie.push(o);
    });
    return sortie;
  }

  var lus = lireTexte(window.SCDM_CODES_TEXTE);
  var source = lus.length ? 'page' : 'secours';
  if (!lus.length) {
    lus = SECOURS.map(function (o) {
      return { code: o.code, pct: o.pct / 100, debut: null, fin: null };
    });
  }

  window.SCDM_CODES_LUS = lus;
  window.SCDM_CODES_SOURCE = source;

  /* On etablit d abord la liste des codes acceptes aujourd hui. Elle est
     publiee meme sur une page sans configurateur (la page « Codes promo »
     s en sert pour relire ce qui a ete compris). */
  var now = new Date();
  var actifs = {};

  lus.forEach(function (o) {
    if (o.debut && now < lireDate(o.debut)) return;
    if (o.fin && now >= lireDate(o.fin)) return;
    actifs[o.code] = o.pct;
  });

  CALENDRIER.forEach(function (p) {
    if (p.type === 'code' && enCours(p, now)) actifs[p.code] = p.pct;
  });

  window.SCDM_CODES_ACTIFS = actifs;

  var D = window.SCDM_DATA;
  if (!D) return;                 // page sans configurateur : rien de plus a faire

  D.PROMOS_AUTO = D.PROMOS_AUTO || [];

  /* La page est la table, pas un ajout : on repart a vide, sinon un code
     efface sur la page continuerait de vivre dans scdm-data.js. */
  D.CODES = {};
  Object.keys(actifs).forEach(function (c) { D.CODES[c] = actifs[c]; });

  CALENDRIER.forEach(function (p) {
    if (p.type !== 'auto') return;
    var deja = D.PROMOS_AUTO.some(function (x) { return x.nom === p.nom; });
    if (!deja) {
      D.PROMOS_AUTO.push({ nom: p.nom, debut: p.debut, fin: p.fin, paliers: p.paliers });
    }
  });
})();
